module.exports = __webpack_public_path__ + "static/media/test4_4.190b303c.png";